// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class FloorLabelMessage implements flatbuffers.IUnpackableObject<FloorLabelMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FloorLabelMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFloorLabelMessage(bb:flatbuffers.ByteBuffer, obj?:FloorLabelMessage):FloorLabelMessage {
  return (obj || new FloorLabelMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFloorLabelMessage(bb:flatbuffers.ByteBuffer, obj?:FloorLabelMessage):FloorLabelMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FloorLabelMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

floorLabels(index: number):string
floorLabels(index: number,optionalEncoding:flatbuffers.Encoding):string|Uint8Array
floorLabels(index: number,optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
}

floorLabelsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startFloorLabelMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addFloorLabels(builder:flatbuffers.Builder, floorLabelsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, floorLabelsOffset, 0);
}

static createFloorLabelsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startFloorLabelsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endFloorLabelMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 4) // floor_labels
  return offset;
}

static createFloorLabelMessage(builder:flatbuffers.Builder, floorLabelsOffset:flatbuffers.Offset):flatbuffers.Offset {
  FloorLabelMessage.startFloorLabelMessage(builder);
  FloorLabelMessage.addFloorLabels(builder, floorLabelsOffset);
  return FloorLabelMessage.endFloorLabelMessage(builder);
}

unpack(): FloorLabelMessageT {
  return new FloorLabelMessageT(
    this.bb!.createScalarList<string>(this.floorLabels.bind(this), this.floorLabelsLength())
  );
}


unpackTo(_o: FloorLabelMessageT): void {
  _o.floorLabels = this.bb!.createScalarList<string>(this.floorLabels.bind(this), this.floorLabelsLength());
}



unpackFields(...fields: string[]): FloorLabelMessageT {
  const t = new FloorLabelMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('floor_labels')) {
    t.floorLabels = this.bb!.createScalarList<string>(this.floorLabels.bind(this), this.floorLabelsLength());
  }
  return t;
}
}

export class FloorLabelMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public floorLabels: (string)[] = []
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  if (this.floorLabels === null || this.floorLabels === undefined) {
    throw new Error('Required field "floor_labels" is not set');
  }
  const floorLabels = FloorLabelMessage.createFloorLabelsVector(builder, builder.createObjectOffsetList(this.floorLabels));

  return FloorLabelMessage.createFloorLabelMessage(builder,
    floorLabels
  );
}

clone(): FloorLabelMessageT {
  const obj = new FloorLabelMessageT();
  obj.floorLabels = [...this.floorLabels];
  return obj;
}

equals(other: FloorLabelMessageT): boolean {
  if (this.floorLabels.length !== other.floorLabels.length) return false;
  for (let i = 0; i < this.floorLabels.length; i++) {
    if (this.floorLabels[i] !== other.floorLabels[i]) return false;
  }
  return true;
}
}

export function verifyFloorLabelMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    verifier.checkRequiredField(tablePos, 4, 'floor_labels');
  } finally {
    verifier.popDepth();
  }
}
